module.exports = __webpack_public_path__ + "static/img/20161125.feb0ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20161125.jpg
// module id = CYsB
// module chunks = 98